<div #content class=" mb-2" [class.expanded]="isExpanded" [class.expand-content] ="isOverflowing">
    <ng-content></ng-content>
</div>
<dx-button
  *ngIf="isOverflowing"
  stylingMode="text"
  type="default"
  text="{{ !isExpanded ? textShowMore : textShowLess }}"
  (click)="toggle()"
></dx-button>
